import { TabModel } from "@genexus/chameleon-controls-library";
import { DesignType } from "./design-import";

export const TAB_DATA: { [key in TAB_SELECTOR]: TabData } = {
  layout: { id: "layout", caption: "Layout", slot: "layout" },
  code: { id: "code", caption: "Code", slot: "code" },
  tokens: { id: "tokens", caption: "Tokens", slot: "tokens" },
  styles: { id: "styles", caption: "Styles", slot: "styles" },
  composition: {
    id: "composition",
    caption: "Composition",
    slot: "composition"
  }
};

export const TAB_MODEL: TabDataModel = {
  panels: [
    {
      id: TAB_DATA.composition.id,
      name: TAB_DATA.composition.caption
    },
    {
      id: TAB_DATA.layout.id,
      name: TAB_DATA.layout.caption
    },
    {
      id: TAB_DATA.code.id,
      name: TAB_DATA.code.caption
    }
  ],
  stencils: [
    {
      id: TAB_DATA.composition.id,
      name: TAB_DATA.composition.caption
    },
    {
      id: TAB_DATA.layout.id,
      name: TAB_DATA.layout.caption
    },
    {
      id: TAB_DATA.code.id,
      name: TAB_DATA.code.caption
    }
  ],
  images: [
    {
      id: TAB_DATA.composition.id,
      name: TAB_DATA.composition.caption
    }
  ],
  fonts: [
    {
      id: TAB_DATA.composition.id,
      name: TAB_DATA.composition.caption
    }
  ],
  designSystem: [
    {
      id: TAB_DATA.tokens.id,
      name: TAB_DATA.tokens.caption
    },
    {
      id: TAB_DATA.styles.id,
      name: TAB_DATA.styles.caption
    }
  ]
};

export type TabDataModel = {
  panels: TabModel;
  stencils: TabModel;
  images: TabModel;
  fonts: TabModel;
  designSystem: TabModel;
};

type TabData = {
  id: TAB_SELECTOR;
  caption: string;
  slot: TAB_SELECTOR;
};

export type TAB_SELECTOR =
  | "layout"
  | "code"
  | "tokens"
  | "styles"
  | "composition";

export const DESIGN_TYPE_TO_TAB_MODEL_MAP = new Map<DesignType, TabModel>([
  ["panels", TAB_MODEL.panels],
  ["stencils", TAB_MODEL.stencils],
  ["images", TAB_MODEL.images],
  ["design_system", TAB_MODEL.designSystem],
  ["fonts", TAB_MODEL.fonts]
]);
